/**
 * Created by eyal.albilia on 11/19/17.
 */
import type { JSX, ReactNode } from "react";
import { PureComponent } from "react";

import styled from "styled-components";

import { PlainTooltip, CircleSwitcherItem, Switcher } from "@similarweb/ui-components";

import { i18nFilter, translate } from "app/filters/i18nFilter";

const SwitcherItemWrapperForTooltip = styled.div<{ disabled: boolean }>`
    ${({ disabled }) => (disabled ? "cursor: not-allowed;" : "")}
`;

interface ISwitcherGranularityContainer {
    selectedIndex: number;
    itemList: Array<{
        tooltipText?: ReactNode;
        title: ReactNode;
        disabled?: boolean;
        isLocked?: boolean;
        dataAutomation?: string;
    }>;
    onItemClick: (newIndex: number | string) => void;
    className?: string;
    customClass?: string;
}
export class SwitcherGranularityContainer extends PureComponent<ISwitcherGranularityContainer> {
    private i18n: ReturnType<typeof i18nFilter>;

    public constructor(props: ISwitcherGranularityContainer) {
        super(props);
        this.i18n = i18nFilter();
    }

    public onItemClick = (value) => {
        this.props.onItemClick(value);
    };

    public render(): JSX.Element {
        if (!Array.isArray(this.props.itemList) || this.props.itemList.length === 0) {
            return null;
        }

        const switcherItems = this.props.itemList.map((item, index) => {
            const selected = index === this.props.selectedIndex;
            const dataAutomation =
                item.dataAutomation ?? (typeof item.title === "string" ? item.title : `circle-switcher-tab-${index}`);
            if (item.tooltipText) {
                return (
                    <SwitcherItemWrapperForTooltip
                        disabled={item.disabled}
                        key={`circle-switcher-item-${index}`}
                    >
                        <PlainTooltip
                            tooltipContent={
                                typeof item.tooltipText === "string" ? this.i18n(item.tooltipText) : item.tooltipText
                            }
                        >
                            <div>
                                <CircleSwitcherItem
                                    disabled={item.disabled}
                                    selected={selected}
                                    isLocked={item.isLocked}
                                >
                                    <span data-automation={dataAutomation}>
                                        {typeof item.title === "string" ? this.i18n(item.title) : item.title}
                                    </span>
                                </CircleSwitcherItem>
                            </div>
                        </PlainTooltip>
                    </SwitcherItemWrapperForTooltip>
                );
            } else {
                return (
                    <CircleSwitcherItem
                        key={`circle-switcher-item-${index}`}
                        disabled={item.disabled}
                        className={index === this.props?.itemList.length ? "last" : ""}
                        selected={selected}
                        isLocked={item.isLocked}
                    >
                        <span data-automation={dataAutomation}>
                            {typeof item.title === "string" ? this.i18n(item.title) : item.title}
                        </span>
                    </CircleSwitcherItem>
                );
            }
        });
        return (
            <Switcher
                selectedIndex={this.props.selectedIndex}
                customClass={this.props.customClass}
                onItemClick={this.onItemClick}
                className={this.props.className}
            >
                {switcherItems}
            </Switcher>
        );
    }
}
